import { Colors } from "../preset.constants";

export const dialogPreset = {
    background: Colors.PrimaryBackground,
    color: Colors.DefaultTextColor
}